<template>
  <div
    class="absolute top-0 left-0 w-full h-full flex justify-content-center align-items-center bg-black-alpha-40"
  >
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
  </div>
</template>
